import { useCallback, useEffect, useRef } from 'react';

/**
 * Only the NEWEST request counts (Apal 2026-11-02: "if i click on something
 * else on filter, you have to cancel previous request and only focus on new
 * request"). Each call aborts the request before it and hands back:
 *   signal    — pass to the API call so the browser drops the old one;
 *   isCurrent — false once a newer request (or unmount) has replaced it, so
 *               a late answer can never overwrite newer numbers, and only the
 *               newest request turns the "Updating" strip off.
 */
export function useLatestRequest() {
  const ref = useRef(null);
  useEffect(() => () => { if (ref.current) ref.current.abort(); }, []);
  return useCallback(() => {
    if (ref.current) ref.current.abort();
    const c = new AbortController();
    ref.current = c;
    return { signal: c.signal, isCurrent: () => ref.current === c && !c.signal.aborted };
  }, []);
}

/** A request we cancelled ourselves — never an error to show. */
export const isCanceled = (e) => !!e && (e.name === 'CanceledError' || e.code === 'ERR_CANCELED' || e.name === 'AbortError');
